module.exports = __webpack_public_path__ + "mainassets/img/meshlin_arrow.3dc4e7d7.svg";